/**
 * Log Error message in console.
 *
 * @param message - The error message to log.
 * @param errorInstance - Optional error instance.
 */
const error = (message, errorInstance) => {
    const isDev = process.env.NODE_ENVIRONMENT === 'development';
    const type = isDev ? 'error' : 'warn';
    const color = isDev ? '#EC3941' : '#F5BD01';
    // We are intentionally logging the message in console
    // eslint-disable-next-line no-console
    console[type](`%c %c ${message}`, `color: white; background: ${color}; font-size: 14px;`, 'color: reset; background: transparent;', '\n\n', errorInstance);
};
export default error;
//# sourceMappingURL=error.js.map